/* eslint-disable react/prop-types */
import { useMemo } from 'react';
import { useJsApiLoader, GoogleMap, Polyline } from '@react-google-maps/api';
import { Marcador } from './Marcador';

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

const containerStyle = {
  width: '1000px',
  height: '500px'
};

export const Mapa = (props) => {
  const options = {
    strokeColor: '#FF0000',
    strokeOpacity: 0.8,
    strokeWeight: 2,
    fillColor: '#FF0000',
    fillOpacity: 0.35,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    radius: 30000,
    paths: [],
    zIndex: 1
  };
  const { center, onLoad, streetViewControlMap, zoom, markersProps, routes } = props;
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: API_KEY
  });
  const { points, onClick } = markersProps;

  const markers = useMemo(
    () =>
      points.map((point) => (
        <Marcador data={point} onClick={onClick} key={`p-${point.idUbicacion}`} />
      )),
    [points, routes]
  );

  const mapOptions = {
    streetViewControl: streetViewControlMap,
    mapTypeControl: false,
    clickableIcons: false
  };

  // const onLoad2 = (polyline) => {
  // console.log('polyline: ', polyline);
  // };

  const routePolylines = useMemo(
    () =>
      routes.map((route) => {
        const coord = route.map((r) => r.cordenadas);
        options.paths = coord;
        return (
          <Polyline
            path={coord}
            options={options}
            // onLoad={onLoad2}
            key={`pl-${route.idUbicacion}`}
          />
        );
      }),
    [routes]
  );

  if (!isLoaded) return <span>cargando ...</span>;
  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      onLoad={onLoad}
      options={mapOptions}
      zoom={zoom}>
      {[...markers, routePolylines]}
    </GoogleMap>
  );
};
